import { APP_BASE_HREF } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { SecurityService } from '@app/_core/services/security.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MessageService } from 'primeng/api';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { TranscriptService } from '@app/_core/services/transcript-service.service';
@Component({
  selector: 'app-view-voicemail-details',
  templateUrl: './view-voicemail-details.component.html',
  styleUrls: ['./view-voicemail-details.component.scss'],
  providers: [MessageService],
})
export class ViewVoicemailDetailsComponent implements AfterViewInit, OnDestroy {
  loading: boolean;
  modalRef?: BsModalRef;
  title?: string;
  data: any;
  recordingDetails: any;
  audioSource: string = '';
  isRecordLoaded: boolean = false;
  transcriptSpeaker: string = '';
 
  transcriptText: string = '';
 
  @Output() deleted = new EventEmitter<number>();
  @Output() closeWindow: EventEmitter<Boolean> = new EventEmitter<boolean>();
  deleteVoicemailTimeout: any;
  constructor(
    private cdr: ChangeDetectorRef,
    private utils: Utils,
    private webStorage: WebStorageService,
    private appService: AppService,
    private managerService: ManagerService,
    private securityService: SecurityService,
    private router: Router,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    public bsModalRef: BsModalRef,
    private messageService: MessageService,
    private transcriptService: TranscriptService,
    private queueServices: QueuesService,
    private tmqueueService: TmQueueService,
    private mainController: MainControllerComponent,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const file: any = this.data?.URL;
    this.loadVoicemailAudio(file);
    this.getVoicemailTranscript(this.data?.InteractionID);
  }

  closeVoicemailsPopup() {
    //console.log(this.router.url, "this.router.url");
     // Reset Queue
     this.appService.setSelectedQueueType(this.router.url.split("?")[0].split("/").pop());
     // Reset QueueID
     this.queueServices.setselectedQueueId(this.data.QueueID);
     this.appService.setselectedQueueId(this.data.QueueID);
     this.bsModalRef.hide();
  }

  loadVoicemailAudio(file: any) {
    this.managerService.getRecordingFiles(file).subscribe(data => {
     // console.log('loadVoicemailAudio', data);
      const binaryData = 'data:' + data.MimeType + ';base64,' + data.result;
      const binary = Utils.convertDataURIToBinary(binaryData);
      const blob = new Blob([binary], { type: data.MimeType });
      const blobUrl = URL.createObjectURL(blob);
      this.audioSource = blobUrl;
      this.recordingDetails = this.audioSource;
      this.isRecordLoaded = true;
     // console.log(blobUrl, this.recordingDetails);
    });
  }

  deleteVoicemail() {
    const payload = {
      id: this.data?.ID,
     // agentID: this.data?.AgentID,
      status: 'Deleted',
    };

    this.managerService.EditVoicemail(payload).subscribe(response => {
     // console.log('deleteVoicemail', response);
     let Success=response.Response.Status==1?"Success":"Error";
     let detail=response.Response.Status==1?"Voicemail deleted successfuly":response.Response.Message;
       this.messageService.add({
             severity: Success.toLowerCase(),
             summary: Success,
             detail: detail
           });
      this.deleted.emit(this.data?.ID);
      this.deleteVoicemailTimeout = setTimeout(() => {
        this.closeVoicemailsPopup();
      }, 3000);
    });
  }

  replyToVoiceMail() {
   // console.log('this.data', this.data);
      this.mainController.setIsCaseUserUnmapped(null);
    const companyCode = Utils.fetch('clientAbbreviation');
    const menuName = companyCode + '/Queue/caseDetails';
    this.closeWindow.emit(true);
    //this.closeVoicemailsPopup();
    this.bsModalRef.hide();
    const url = this.data.QueueID + '-' + this.data.UserID + '-' + null;
    this.appService.setActivityId(this.data.ActivityID);
    this.queueServices.setselectedQueueId(this.data.QueueID);
    this.queueServices.SetVoicemailDetails(this.data);
    this.appService.setSelectedQueueName(this.data.Queue);
    //his.queueServices.SetQueue(this.data.Queue);
    this.queueServices.SetVoiceMailNav(true);
    this.appService.setActionItemId(url);
    this.queueServices.SetVoicemailDetailsReply(true);
    
    this.queueServices.SetVoicemailDetailsReplyForChangeUser(true);
    this.router.navigate([menuName]);
  }

  ngOnDestroy(): void {
    this.deleteVoicemailTimeout && clearTimeout(this.deleteVoicemailTimeout);
  }
  getVoicemailTranscript(interactionId: number) {
    this.transcriptService.
    GetPostCallAnalyticsByInteractionID(interactionId, 3)
      .subscribe(
        (res: any) => {
         
          const transcriptData = res?.Response?.Data;
 
          if (transcriptData?.Sentences?.length) {
 
            this.transcriptSpeaker =
              transcriptData.Sentences[0]?.SpeakerRole || 'Transcript';
 
              this.transcriptText =
              transcriptData.Sentences
                .map((x: any) => x.Transcript)
                .join('\n\n');
          }
        },
        err => {
          console.log('Transcript Error', err);
        }
      );
  }
}
